import { useQuery } from 'react-query';
import { fetchMoviesNowPlaying } from '../services/api';

export const useMoviesNowPlaying = options => {
  return useQuery('moviesNowPlaying', fetchMoviesNowPlaying, options);
};
